import { useEffect, useState } from "react";

// Toast mínimo pra erros de mutação que antes falhavam em silêncio.
// ponytail: pub/sub de módulo, sem contexto — um host global em _authed.

type Toast = { id: number; message: string };
let nextId = 1;
let listener: ((t: Toast) => void) | null = null;

export function toastError(message: string) {
  listener?.({ id: nextId++, message });
}

export function ToastHost() {
  const [toasts, setToasts] = useState<Toast[]>([]);

  useEffect(() => {
    listener = (t) => {
      setToasts((prev) => [...prev, t]);
      setTimeout(() => setToasts((prev) => prev.filter((x) => x.id !== t.id)), 5000);
    };
    return () => { listener = null; };
  }, []);

  if (toasts.length === 0) return null;
  return (
    <div style={{ position: "fixed", bottom: 16, right: 16, zIndex: "var(--z-toast)" as any, display: "flex", flexDirection: "column", gap: 8 }}>
      {toasts.map((t) => (
        <div
          key={t.id}
          role="alert"
          style={{
            background: "var(--surface-card)", border: "1px solid var(--danger-soft-line)",
            borderRadius: 10, boxShadow: "var(--shadow-pop)", padding: "10px 14px",
            fontSize: 12, color: "var(--danger)", maxWidth: 340,
            animation: "toast-in 0.2s var(--ease-out-quint)",
          }}
        >
          {t.message}
        </div>
      ))}
    </div>
  );
}
